import { Accommodation, PerformerRequest } from '@silbo/core';
import { createFileRoute, Outlet } from '@tanstack/react-router';
import ArchivesPage from '../../../features/bed-management/pages/ArchivesPage';
import { getArchivedRequestsQueryOptions, getUnitsQueryOptions } from '../../../features/bed-management/queries';
import { getAccommodationsFromRequestsQueryOptions } from '../../../features/bed-management/queries/get-accommodations-from-requests';

export const Route = createFileRoute('/_auth/bed-management/archives')({
  loader: async ({ context }) => {
    const { user, healthCenter } = context.authenticationContext;
    if (!user || !healthCenter) {
      return undefined;
    }

    const userUnitIds = user.units?.map((unit) => unit.id) || [];

    const units = await context.queryClient.ensureQueryData(
      getUnitsQueryOptions('bedManagement', healthCenter, userUnitIds)
    );

    let requests: PerformerRequest[] = [];
    let accommodations: Accommodation[] = [];
    if (units.length > 0) {
      requests = await context.queryClient.ensureQueryData(getArchivedRequestsQueryOptions(new Date(), units));

      if (requests.length > 0) {
        accommodations = await context.queryClient.ensureQueryData(
          getAccommodationsFromRequestsQueryOptions(requests.map((request) => request.request))
        );
      }

      return { requests, accommodations };
    }

    return {
      requests,
      accommodations,
    };
  },
  component: RouteComponent,
});

function RouteComponent() {
  const { requests, accommodations } = Route.useLoaderData() || { requests: [], accommodations: [] };

  return (
    <>
      <ArchivesPage requests={requests} accommodations={accommodations} />
      <Outlet />
    </>
  );
}
